<template>
  <v-menu
    v-model="open"
    location="bottom"
    max-width="455"
    :close-on-content-click="false"
  >
    <template #activator="{ props }">
      <div id="filter-search">
        <DpplChip
          class="filter-search-chip"
          color="white"
          variant="flat"
          :chip-height="32"
          reduce-font-size
          :disabled="loading"
          :is-active="open"
          role="button"
          v-bind="props"
        >
          <template #pre-icon>
            <v-icon
              size="16px"
              class="pr-1"
              icon="$magnify"
            />
          </template>
          <template #label>
            {{ searchLabel }}
          </template>
          <v-hover v-slot="{ isHovering: closeMenu, props: hoverProps }">
            <v-btn
              v-show="activeSearch"
              v-bind="hoverProps"
              icon
              elevation="0"
              width="20"
              height="20"
              variant="flat"
              class="text-white ml-2"
              aria-label="Search"
              :color="closeMenu && activeSearch ? 'orange500' : 'success'"
              @click.stop="updateSearch({ clear: true })"
            >
              <IconCheck v-if="activeSearch && !closeMenu" />
              <IconClose v-show="activeSearch && closeMenu" />
            </v-btn>
          </v-hover>
        </DpplChip>
      </div>
    </template>
    <v-card width="455" class="filter-search-filter-card">
      <v-card-actions class="filter-card-actions">
        <DpplTextField
          ref="searchInput"
          v-model.trim="search"
          class="text-filter-input"
          :label="inputLabel"
          hide-details
          autofocus
          @keydown.enter="updateSearch"
        />
        <DpplAutoSizedButton
          :disabled="search === activeSearch"
          height="32"
          width="63"
          small
          class="text-filter-button text-capitalize"
          @click="updateSearch"
        >
          Apply
        </DpplAutoSizedButton>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
import DpplChip from '@/components/datapeople/DpplChip.vue';
import DpplAutoSizedButton from '@/components/datapeople/DpplAutoSizedButton.vue';
import DpplTextField from '@/components/datapeople/DpplTextField.vue';
import { debounce } from 'lodash-es';
import IconClose from '@/assets/icon-close.svg?component';
import IconCheck from '@/assets/icon-check.svg?component';

export default {
  name: 'FilterSearch',
  components: {
    DpplChip,
    IconClose,
    IconCheck,
    DpplTextField,
    DpplAutoSizedButton,
  },
  props: {
    activeSearch: { type: String, default: '' },
    loading: { type: Boolean, default: false },
    inputLabel: { type: String, default: 'Search Name and Email' },
  },
  emits: ['update-search', 'set-page'],
  data() {
    return {
      open: false,
      search: this.$route.query?.q || '',
    };
  },
  computed: {
    searchLabel() {
      return this.activeSearch ? `"${this.activeSearch}"` : 'Text Search';
    },
  },
  watch: {
    search(newValue) {
      this.$emit('set-page');
      this.handleSearchChange(newValue);
    },
  },
  methods: {
    updateSearch({ clear }) {
      this.open = false;
      if (clear) {
        this.search = '';
      }
      const searchTerm = clear ? '' : this.search;
      this.$emit('update-search', { searchTerm });
    },
    handleSearchChange: debounce(function onSearchChangeDebounced(search) {
      this.$router.push({
        query: { page: 1, q: search || undefined },
      }).catch(() => false);
    }, 500),
  },
};
</script>

<style lang="less" scoped>
#filter-search {
  position: relative;
  .filter-search-chip {
    margin-right: 8px;
  }
}
</style>

<style lang="less">
.filter-search-filter-card {
  @import '@/less/mixins';
  .v-menu__content {
    .shadow();
  }
  div.v-card-actions.filter-card-actions {
    padding: 0;
    padding-right: 16px;
    display: flex;
    .text-filter-input {
      flex-grow: 1;
      padding: 8px 16px;
      width: 300px;

      .v-input {
        padding-left: 0 !important;
      }
    }
    .text-filter-button {
      margin-top: 20px;
      padding-right: 16px;
    }
  }
}
</style>
